export const pet = {
  data: [{
    title: '开心宠物之家',
    location: '北京市朝阳区',
    public: '李先生',
    mobile: '18610029643',
    address: '北京市朝阳区幸福路88号'
  }, {
    title: '宠物乐园',
    location: '上海市黄浦区',
    public: '王女士',
    mobile: '13980219376',
    address: '上海市黄浦区南京东路123号'
  }, {
    title: '宠爱一生宠物店',
    location: '广州市越秀区',
    public: '赵先生',
    mobile: '15801283371',
    address: '广州市越秀区中山三路45号'
  }, {
    title: '毛孩子乐园',
    location: '深圳市南山区',
    public: '张小姐',
    mobile: '13610206982',
    address: '深圳市南山区南海大道200号'
  }, {
    title: '宠物天堂',
    location: '成都市锦江区',
    public: '刘先生',
    mobile: '13773590139',
    address: '成都市锦江区红星路一段99号'
  }, {
    title: '爱宠家园',
    location: '杭州市西湖区',
    public: '孙女士',
    mobile: '13565980133',
    address: '杭州市西湖区文一路78号'
  }, {
    title: '宠物小屋',
    location: '南京市鼓楼区',
    public: '周先生',
    mobile: '15911104273',
    address: '南京市鼓楼区汉中路56号'
  }, {
    title: '宠物之家',
    location: '重庆市渝北区',
    public: '吴女士',
    mobile: '13811789201',
    address: '重庆市渝北区龙溪街道99号'
  }, {
    title: '小宠物乐园',
    location: '武汉市武昌区',
    public: '何先生',
    mobile: '13768901847',
    address: '武汉市武昌区中南路55号'
  }, {
    title: '宠物宝贝店',
    location: '天津市河西区',
    public: '韩小姐',
    mobile: '18693894762',
    address: '天津市河西区友谊路100号'
  }, {
    title: '宠物之家',
    location: '苏州市姑苏区',
    public: '陈先生',
    mobile: '13501788392',
    address: '苏州市姑苏区观前街66号'
  }, {
    title: '爱宠乐园',
    location: '重庆市南岸区',
    public: '杨女士',
    mobile: '13998216733',
    address: '重庆市南岸区南坪东路33号'
  }]
}